export const inputOutlineOverride = {
	'& .MuiOutlinedInput-root.Mui-focused': {
		'& > fieldset': {
			borderColor: '#293264',
		},
	},
	'& .MuiInputLabel-root.Mui-focused': {
		color: '#293264',
	},
};

export const answerDefault = {
	backgroundColor: 'transparent',
};
export const answerSelected = {
	backgroundColor: '#D6DbF5',
};

export const answerCorrect = {
	backgroundColor: '#94D7A2',
};

export const answerIncorrect = {
	backgroundColor: '#F8BCBC',
};
